
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M16 2.7c.4-.4 1-.7 1.6-.7.6 0 1.2.1 1.6.5.4.4.7 1 .7 1.6 0 .6-.1 1.2-.5 1.7L9.5 17.2c-.3.5-.9.8-1.5.8-.3 0-.6 0-.8-.1-.3-.1-.5-.2-.7-.4L1 12.8c-.3-.2-.5-.4-.6-.7-.2-.3-.3-.6-.3-.9 0-.3 0-.6.1-.9.1-.3.2-.6.5-.8.2-.3.4-.5.7-.6.3-.1.6-.2.9-.2.3 0 .6 0 .9.1.3.1.6.3.8.5l3.5 3.1L16 2.7z"}})])
          )
        }
      }
    